// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__1U6vd","title":"Card_title__2Hzvp"};